<template>
	<sky-charts
		:api-conf="apiConf"
		ref="chart"
		:before-render="beforeRender"
		:queryCondition="condition"
		:config="chartConfig"
	>
		<div slot="left" style="width: 30%; max-width: 300px">
			<ga-card-item
				:class="{ active: type == 'visitorCount' }"
				@click.native="getResult('visitorCount')"
				:label="label.visitorCount"
				:value="data.visitorCount"
				tips="日期范围内至少发起过一次会话的用户"
			></ga-card-item>
			<ga-card-item
				:class="{ active: type == 'pvCount' }"
				@click.native="getResult('pvCount')"
				:label="label.pvCount"
				:value="data.pvCount"
				tips="该网站总浏览量"
			></ga-card-item>
			<ga-card-item
				:class="{ active: type == 'sessionBounces' }"
				@click.native="getResult('sessionBounces')"
				:label="label.sessionBounces"
				:value="data.bounceRatio"
				tips="未与网页进行互动的单页会话次数所占的百分比"
			></ga-card-item>
			<ga-card-item
				:class="{ active: type == 'avgVisitTime' }"
				@click.native="getResult('avgVisitTime')"
				:label="label.avgVisitTime"
				:value="data.avgVisitTimeStr"
				tips="会话的平均长度"
			></ga-card-item>
		</div>
	</sky-charts>
</template>

<script>
import dayjs from 'dayjs';
import apiConf from '@/backend/apiConfig/apiConfig';
import gaCardItem from '@/components/website/ga_card/ga_card_item/ga_card_item';
import mixins from './ga_mixins';
import weburlSelect from '@/components/website/weburlSelect.js';
export default {
	name: 'ga_base_data',
	// mixins: [mixins],
	props: {
		condition: {
			required: false,
		},
	},
	components: {
		gaCardItem,
	},
	data() {
		const that = this;
		return {
			apiConf: null,
			chartConfig: {
				name: '网站数据',
				type: 'veLine',
				columns: ['showTimeStr', 'visitorCount'], //,'pvCount','sessionCount','sessionDuration'
				chartSettings: {
					// 设置别名
					labelMap: {
						visitorCount: '用户数量',
						pvCount: '页面浏览次数',
						sessionBounces: '会话跳出次数',
						avgVisitTime: '会话时长',
					},
					// 设置数据格式
					yAxisType: [
						val => {
							if (that.type === 'avgVisitTime') {
								return dayjs(val * 1000).format('mm:ss');
							}
							return val;
						},
					],
				},
				// 队列
				extend: {
					yAxis: {
						axisLabel: {
							formatter(val) {
								if (that.type == 'avgVisitTime') {
									return dayjs(val * 1000).format('mm:ss');
								}
								return val;
							},
						},
					},
				},
			},
			data: {},
			type: 'visitorCount',
			label: '',
		};
	},
	watch: {
		condition: {
			handler(val) {
				this.apiConf = {
					api: apiConf.website['get' + weburlSelect(val.status) + 'MainReport'],
					config: {
						timeout: 60000,
					},
				};

				this.label = this.labelMap(val.status);
			},
			immediate: true,
			deep: true,
		},
	},
	methods: {
		getResult(type) {
			if (this.type !== type) {
				this.type = type;
				this.chartConfig.columns[1] = type;
				this.$set(this.chartConfig.columns, 1, type);
				// this.$refs.chart && this.$refs.chart.initCharts();
			}
		},
		beforeRender(data) {
			if (data.bounceRatio) {
				data.bounceRatio = `${data.bounceRatio}%`;
			}
			this.data = data;
			return data.dayDetailList;
		},
		labelMap(status) {
			let objGA = {
				visitorCount: '用户数量',
				pvCount: '浏览量',
				sessionBounces: '跳出率',
				avgVisitTime: '平均会话时长',
			};
			let objBd = {
				visitorCount: '访客数',
				pvCount: '浏览量',
				sessionBounces: '跳出率',
				avgVisitTime: '平均会话时长',
			};

			return status === 1 ? objGA : status === 2 ? objBd : '';
		},
	},
};
</script>

<style scoped></style>
